function getTenantState(state) {
  return state.tenant;
}

export function getTenant(state) {
  return getTenantState(state).tenant;
}

export default getTenant;
